import { useEffect, useState } from "react"
import { feedService } from "../../../../services/feedService.ts"
import {
  DASHBOARD_PREVIEW_FETCH_LIMIT,
  mapFeedItemsToPreviewCards,
  type FeedPreviewCardModel,
} from "../../../../utils/feedDashboardPreview.ts"

export function useDashboardFeedPreview(enabled: boolean) {
  const [cards, setCards] = useState<FeedPreviewCardModel[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!enabled) return undefined
    let cancelled = false
    setLoading(true)
    setError(false)

    feedService
      .getFeedExplore({ view: "mostrar", limit: DASHBOARD_PREVIEW_FETCH_LIMIT })
      .then((page) => {
        if (cancelled) return
        setCards(mapFeedItemsToPreviewCards(page.items))
      })
      .catch(() => {
        if (cancelled) return
        setCards([])
        setError(true)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [enabled])

  return { cards, loading, error }
}
